const relatedPosts = {
  $postsContainer: document.querySelector('#main_footer .be-ix-link-block'),
  init() {
    if (!this.$postsContainer) {
      return;
    }

    this.getBeJson()
      .then(data => {
        const {headStr, postsHtml} = this.processBeJson(data);

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = headStr;

        if (tempDiv.children.length) {
          [...tempDiv.children]
            .forEach($child => {
              document.head.appendChild($child);
            });
        }

        if (this.$postsContainer && postsHtml.length > 2) {
          this.$postsContainer.innerHTML = postsHtml;
        }
      });
  },

  getBeJson() {
    const endpoint = 'https://ixfd-api.bc0a.com/api/ixf/1.0.0/get_capsule/';
    const accId = 'f00000000108313';
    const pageHash = this.getPageHash(location.href);

    return new Promise(resolve => {
      fetch(endpoint + accId + '/' + pageHash)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          return response.json();
        })
        .then(data => resolve(data))
        .catch(error => console.error('There has been a problem with brightedge fetch operation: ', error));
    });
  },

  processBeJson({key, page_group_nodes, nodes}) {
    // const isPage = (key === '-0');
    let postsHtml = '';
    let headStr = '';

    if (nodes && nodes.length) {
      nodes.forEach(node => {
        if (node.type === 'bodystr' && node.content && node.content.length) {
          postsHtml += node.content;
        }

        if (node.type === 'headstr' && node.content && node.content.length) {
          headStr += node.content;
        }
      });
    }

    if (postsHtml.length < 2) {
      if (page_group_nodes['Global Settings']
      && page_group_nodes['Global Settings'].length) {
        page_group_nodes['Global Settings'].forEach(node => {
          if (node.type === 'bodystr' && node.content && node.content.length) {
            postsHtml += node.content;
          }
        });
      }
    }

    return {
      headStr,
      postsHtml
    }
  },

  getPageHash(pageUrl) {
    let hash = 0;

    if (pageUrl === null || pageUrl.length === 0) {
      return hash;
    }

    for (let i = 0; i < pageUrl.length; i++) {
      let charCode = pageUrl.charCodeAt(i);
      hash = ((hash << 5) - hash) + charCode;
      hash = hash & hash; // Convert to 32bit integer
    }

    // if hash is a negative number, remove '-' and append '0' in front
    if (hash < 0) {
      hash = "0" + (-hash);
    } else {
      hash = "" + hash;
    }

    return hash;
  },

  destroy() {
    if (!this.$postsContainer) {
      return;
    }

    this.$postsContainer.innerHTML = '';
  }
};

export default relatedPosts;